import { render, staticRenderFns } from "./ExtensionExplanationModal.vue?vue&type=template&id=d76aaaca&scoped=true"
import script from "./ExtensionExplanationModal.vue?vue&type=script&lang=js"
export * from "./ExtensionExplanationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76aaaca",
  null
  
)

export default component.exports